import { getAlarmDurationDHMSFormat, getAlarmDurationTextFormat } from "app/shared/helper/alarm-duration.helper";

export class Alarms {
  alarms: Alarm[];
  maxNumberOfRows: number;

  static mapPortfolio(data: any) {
    if (data) {
      return new Alarms({
        alarms: data.alarms.map((a: any) => {
          const alarm: Alarm = {
            id: a._id,
            closeTS: a.closeTS,
            code: a.code,
            createTS: a.createTS,
            description: a.description,
            duration: a.duration,
            durationText: getAlarmDurationTextFormat(a.createTS, a.closeTS, a.isOpen),
            durationDHMS:  getAlarmDurationDHMSFormat(a.createTS, a.closeTS, a.isOpen),
            isOpen: a.isOpen,
            productionLoss: a.productionLoss > 1000 ? a.productionLoss / 1000 : a.productionLoss,
            productionUnit: a.productionLoss > 1000 ? 'MWh' : 'kWh',
            turbineCode: a.turbine.code,
            turbineSerial: a.turbine.serialNav,
            durationms: a.closeTS - a.createTS,
            alarmCategory: a.alarmCategory,
            categoryColor: this.getColor(a.alarmCategory)
          };
          return alarm;
        }),
        maxNumberOfRows: data.parks.length
      });
    } else {
      return null;
    }
  }

  static mapPark(data: any) {
    if (data) {
      return new Alarms({
        alarms: data.alarms.map((a: any) => {
          const alarm: Alarm = {
            id: a._id,
            closeTS: a.closeTS,
            code: a.code,
            createTS: a.createTS,
            description: a.description,
            duration: a.duration,
            durationText: getAlarmDurationTextFormat(a.createTS, a.closeTS, a.isOpen),
            durationDHMS:  getAlarmDurationDHMSFormat(a.createTS, a.closeTS, a.isOpen),
            isOpen: a.isOpen,
            productionLoss: a.productionLoss > 1000 ? a.productionLoss / 1000 : a.productionLoss,
            productionUnit: a.productionLoss > 1000 ? 'MWh' : 'kWh',
            turbineCode: a.turbine.code,
            turbineSerial: a.turbine.serialNav,
            durationms: a.closeTS - a.createTS,
            alarmCategory: a.alarmCategory,
            categoryColor: this.getColor(a.alarmCategory)
          };
          return alarm;
        }),
        maxNumberOfRows: data.turbines.length
      });
    } else {
      return null;
    }
  }

  static mapTurbine(data: any) {
    if (data) {
      return new Alarms({
        alarms: data.alarms.map((a: any) => {
          const alarm: Alarm = {
            id: a._id,
            closeTS: a.closeTS,
            code: a.code,
            createTS: a.createTS,
            description: a.description,
            duration: a.duration,
            durationText: getAlarmDurationTextFormat(a.createTS, a.closeTS, a.isOpen),
            durationDHMS:  getAlarmDurationDHMSFormat(a.createTS, a.closeTS, a.isOpen),
            isOpen: a.isOpen,
            productionLoss: a.productionLoss > 1000 ? a.productionLoss / 1000 : a.productionLoss,
            productionUnit: a.productionLoss > 1000 ? 'MWh' : 'kWh',
            turbineCode: a.turbine.code,
            turbineSerial: a.turbine.serialNav,
            durationms: a.closeTS - a.createTS,
            alarmCategory: a.alarmCategory,
            categoryColor: this.getColor(a.alarmCategory)
          };
          return alarm;
        }),
        maxNumberOfRows: 5
      });
    } else {
      return null;
    }
  }

  static getColor(alarmCategory: string) {
    let color = 'rgb(226, 68, 92)';
    switch (alarmCategory) {
      case 'IN_SERVICE':
        color = 'rgb(74, 144, 226)';
        break;
      case 'ALARM_STOP':
        color = 'rgb(226, 68, 92)';
        break;
      case 'LIMITED_OPERATION':
        color = 'rgb(125, 63, 124)';
        break;
      case 'NO_DATA':
        color = 'rgb(179, 185, 189)';
        break;
    }
    return color;
  }

  constructor(init: Partial<Alarms>) {
    Object.assign(this, init);
  }

}

interface Alarm {
  id: string;
  closeTS: number;
  code: string;
  createTS: number;
  description: string;
  duration: string;
  durationText: string;
  durationDHMS: string;
  isOpen: boolean;
  productionLoss: number;
  turbineCode: string;
  turbineSerial: number;
  durationms: number;
  productionUnit: string;
  alarmCategory?: string;
  categoryColor?: string;
}
